module.exports = __webpack_public_path__ + "img/lt.fe3ee2df.svg";